module.exports = __webpack_public_path__ + "static/media/no-img.e49dca69.PNG";